export function SectionEmpty({ message }: { message: string }) {
  return (
    <p className="rounded-lg border border-dashed border-border bg-surface px-s4 py-s6 text-center text-[13px] text-muted">
      {message}
    </p>
  );
}
